var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"project"}},[_c('mProject',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.device == 'mob'),expression:"$store.state.device == 'mob'"}]}),_c('pProject',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.device == 'pc'),expression:"$store.state.device == 'pc'"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }